/*
 * Collection Page (ERMOS) — filtros, ordenacao, grid view-switch e drawer de filtros.
 * So age quando existe [data-collection-page] no DOM (Collection template) — nao afeta
 * nenhuma outra pagina. Filtros/ordenacao sao nativos do Shopify (form GET real,
 * funciona sem JS) com reforco via AJAX (Section Rendering API, ?section_id=) para
 * trocar apenas o grid/contagem/drawer sem reload, preservando back/forward via
 * history.pushState + popstate.
 */
(function () {
  if (window.__ermosCollectionInit) return;
  window.__ermosCollectionInit = true;

  var root = document.querySelector('[data-collection-page]');
  if (!root) return;

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Filter drawer open/close (mesmo padrao do cart-drawer.js) ---------- */
  /* Elementos buscados no momento do uso (não guardados no load): o Theme Editor pode
     recriar a section da coleção, e referências antigas deixariam os filtros mortos. */
  var drawer, scrim, trigger;
  function refs() {
    drawer = qs('[data-filter-drawer]');
    scrim = qs('[data-filter-drawer-scrim]');
    trigger = qs('[data-filter-drawer-open]');
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') closeDrawer();
  }
  function openDrawer() {
    refs();
    if (!drawer) return;
    drawer.hidden = false;
    if (scrim) scrim.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (scrim) { scrim.classList.add('is-open'); scrim.setAttribute('aria-hidden', 'false'); }
    });
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    document.addEventListener('keydown', onKeydown);
  }
  function closeDrawer() {
    refs();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (scrim) { scrim.classList.remove('is-open'); scrim.setAttribute('aria-hidden', 'true'); }
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', onKeydown);
    var d = drawer, sc = scrim;
    setTimeout(function () {
      if (d && !d.classList.contains('is-open')) d.hidden = true;
      if (sc && !sc.classList.contains('is-open')) sc.hidden = true;
    }, 280);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filter-drawer-open]')) { openDrawer(); return; }
    if (e.target.closest('[data-filter-drawer-scrim]') || e.target.closest('[data-filter-drawer-close]')) closeDrawer();
  });

  /* ---------- Accordions dos grupos de filtro ---------- */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('[data-filter-group-toggle]');
    if (!head) return;
    var group = head.closest('[data-filter-group]');
    if (!group) return;
    var expanded = head.getAttribute('aria-expanded') === 'true';
    head.setAttribute('aria-expanded', String(!expanded));
    group.classList.toggle('is-open', !expanded);
  });

  /* ---------- View switch (grid grande/compacta) ---------- */
  var STORAGE_KEY = 'ermos:collectionView';
  function applyView(view) {
    var grid = qs('[data-collection-grid]');
    if (!grid || !view) return;
    grid.setAttribute('data-view', view);
    qsa('[data-view-switch]').forEach(function (b) {
      var active = b.getAttribute('data-view-switch') === view;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }
  var storedView = null;
  try { storedView = localStorage.getItem(STORAGE_KEY); } catch (err) {}
  if (storedView) applyView(storedView);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-view-switch]');
    if (!btn) return;
    var view = btn.getAttribute('data-view-switch');
    applyView(view);
    try { localStorage.setItem(STORAGE_KEY, view); } catch (err) {}
  });

  /* ---------- Filtros/ordenacao: nativo (real, URL-compativel) + reforco AJAX ---------- */
  var controller = null; /* só a última requisição de filtro/ordenação pode renderizar */

  function buildUrl() {
    var form = qs('[data-collection-filter-form]');
    if (!form) return null;
    var params = new URLSearchParams(new FormData(form));
    Array.from(params.keys()).forEach(function (k) {
      if (params.get(k) === '') params.delete(k);
    });
    var base = form.getAttribute('action') || window.location.pathname;
    var qsStr = params.toString();
    return qsStr ? base + '?' + qsStr : base;
  }

  function swapFromHtml(html, pushUrl) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var resultsWrap = qs('[data-collection-results]');
    var newResults = doc.querySelector('[data-collection-results]');
    if (resultsWrap && newResults) {
      resultsWrap.innerHTML = newResults.innerHTML;
      document.dispatchEvent(new CustomEvent('ermos:cards:refresh', { detail: { root: resultsWrap } }));
    }
    var drawerBody = qs('[data-filter-drawer-body]');
    var newDrawerBody = doc.querySelector('[data-filter-drawer-body]');
    if (drawerBody && newDrawerBody) drawerBody.innerHTML = newDrawerBody.innerHTML;

    var triggerCount = qs('[data-filter-trigger-count]');
    var newTriggerCount = doc.querySelector('[data-filter-trigger-count]');
    if (triggerCount && newTriggerCount) triggerCount.outerHTML = newTriggerCount.outerHTML;

    var countEl = qs('[data-collection-count]');
    var newCountEl = doc.querySelector('[data-collection-count]');
    if (countEl && newCountEl) countEl.innerHTML = newCountEl.innerHTML;

    var sortSelect = qs('[data-sort-select]');
    var newSortSelect = doc.querySelector('[data-sort-select]');
    if (sortSelect && newSortSelect) sortSelect.value = newSortSelect.value;

    var storedView = null;
    try { storedView = localStorage.getItem(STORAGE_KEY); } catch (err) {}
    applyView(storedView || 'large');

    if (pushUrl) window.history.pushState({ ermosCollection: true }, '', pushUrl);
  }

  /* Uma nova mudança (filtro/ordem/página/voltar) cancela a anterior em vez de ser
     ignorada: a tela sempre reflete a ÚLTIMA escolha. */
  function fetchAndSwap(url, push) {
    if (!url) return;
    if (controller) controller.abort();
    var mine = controller = new AbortController();
    var resultsWrap = qs('[data-collection-results]');
    if (resultsWrap) resultsWrap.classList.add('is-loading');
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    var sectionRoot = qs('[data-collection-page]');
    var sectionId = sectionRoot ? sectionRoot.getAttribute('data-section-id') : '';
    fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: mine.signal
    })
      .then(function (r) {
        if (!r.ok) throw new Error('bad response');
        return r.text();
      })
      .then(function (html) {
        if (mine !== controller) return;
        swapFromHtml(html, push ? url : null);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.href = url;
      })
      .then(function () {
        if (mine !== controller) return;
        controller = null;
        var wrap = qs('[data-collection-results]');
        if (wrap) wrap.classList.remove('is-loading');
      });
  }

  document.addEventListener('submit', function (e) {
    if (!e.target.matches || !e.target.matches('[data-collection-filter-form]')) return;
    e.preventDefault();
    fetchAndSwap(buildUrl(), true);
    closeDrawer();
  });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches('[data-sort-select]')) {
      fetchAndSwap(buildUrl(), true);
    }
  });

  document.addEventListener('click', function (e) {
    var clearBtn = e.target.closest('[data-filter-clear]');
    var form = qs('[data-collection-filter-form]');
    if (clearBtn && form) {
      e.preventDefault();
      qsa('input[type="checkbox"]', form).forEach(function (i) { i.checked = false; });
      qsa('input[data-filter-price]', form).forEach(function (i) { i.value = ''; });
      fetchAndSwap(form.getAttribute('action') || window.location.pathname, true);
      closeDrawer();
      return;
    }

    var clearAll = e.target.closest('[data-clear-all-filters]');
    if (clearAll) {
      var href = clearAll.getAttribute('href');
      if (href) {
        e.preventDefault();
        fetchAndSwap(href, true);
      }
      return;
    }

    var pageLink = e.target.closest('[data-collection-pagination] a');
    if (pageLink) {
      var pHref = pageLink.getAttribute('href');
      if (pHref) {
        e.preventDefault();
        fetchAndSwap(pHref, true);
        var resultsWrap = qs('[data-collection-results]');
        if (resultsWrap) resultsWrap.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }
  });

  window.addEventListener('popstate', function () {
    fetchAndSwap(window.location.href, false);
  });
})();
